// extracted by mini-css-extract-plugin
export default {"section":"PaymentMethodList_section__Hwf0B","paymentMethodsTitle":"PaymentMethodList_paymentMethodsTitle__Ifr9+","paymentMethods":"PaymentMethodList_paymentMethods__Q9PiG"};